import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // This looks for the default export we added above
import { TenantProvider } from './Common/Contexts/TenantContext';
import { AuthProvider } from './Common/Configurations/AuthContext'; // Import Auth
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider> 
          <App />
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);